/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:be3783da-e19b-4f8b-ac99-88973f4cd739",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_2Z8uoRV60",
    "aws_user_pools_web_client_id": "4obubr3mst592rrko0pji9shuo",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://prqknnmtfbg35l47jxqinw4rja.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-6ekhcjnfe5bedao7lup2pheuoq",
    "aws_cloud_logic_custom": [
        {
            "name": "azingorest",
            "endpoint": "https://51r9h0kjmh.execute-api.us-east-1.amazonaws.com/staging",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "azingostorage160537-staging",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
